/** Tiny same-origin JSON helper for the hub sections (cookie session; the API checks Origin). */
export class HubHttpError extends Error {
  constructor(readonly status: number) {
    super(`HTTP ${status}`);
  }
}

export async function hubFetch<T>(
  path: string,
  init?: { method: "POST" | "PUT" | "DELETE"; body?: unknown },
): Promise<T> {
  const res = await fetch(path, {
    credentials: "include",
    ...(init
      ? {
          method: init.method,
          headers: { "content-type": "application/json" },
          body: JSON.stringify(init.body ?? {}),
        }
      : {}),
  });
  if (!res.ok) throw new HubHttpError(res.status);
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
